module.exports = __webpack_public_path__ + "img/img23.1054c8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/07/img23.jpg
// module id = 289
// module chunks = 0